import Grid from '@mui/material/Grid'
import React, { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

import useLifecycleReasonOptions from 'components/common/account-lifecycle/useLifecycleReasonOptions'
import HHFormSelectField from 'components/form-fields/v5/HHFormSelectField'
import { DRAWER_POPPER_SX } from 'components/taxes/tax-drawer/taxDrawerForm'
import T from 'T'

import type { NewAccountFormValues } from './model'
import type { NewAccountLifecycle } from './useNewAccountLifecycle'

type NewAccountSourceFieldsProps = {
  lifecycle: NewAccountLifecycle
}

const NewAccountSourceFields = ({ lifecycle }: NewAccountSourceFieldsProps) => {
  const {
    control,
    watch,
    resetField,
    formState: { errors },
  } = useFormContext<NewAccountFormValues>()
  const { sourceReasonId: sourceReasonError, sourceCompetitorId: sourceCompetitorError } = errors
  const watchSourceReasonId = watch('sourceReasonId')

  const { reasonOptions, competitorOptions, showCompetitor } = useLifecycleReasonOptions({
    reasons: lifecycle.reasons,
    competitors: lifecycle.competitors,
    isReasonRequired: lifecycle.requireSource,
    selectedReasonId: watchSourceReasonId,
  })

  // A competitor only means something under the reason it was picked for.
  const handleSourceReasonChange = useCallback(() => resetField('sourceCompetitorId'), [resetField])

  if (!lifecycle.isEnabled) return null

  return (
    <>
      <Grid size={12}>
        <HHFormSelectField
          fullWidth
          control={control}
          deprecatedLabel={false}
          error={sourceReasonError?.message}
          helperText={sourceReasonError?.message}
          label={T.WON_REASON}
          name="sourceReasonId"
          options={reasonOptions}
          required={lifecycle.requireSource}
          rules={lifecycle.requireSource ? { required: T.CANNOT_BE_EMPTY } : undefined}
          SelectProps={{ MenuProps: { sx: DRAWER_POPPER_SX } }}
          onChange={handleSourceReasonChange}
        />
      </Grid>
      {showCompetitor && (
        <Grid size={12}>
          <HHFormSelectField
            fullWidth
            required
            control={control}
            deprecatedLabel={false}
            error={sourceCompetitorError?.message}
            helperText={sourceCompetitorError?.message}
            label={T.COMPETITOR}
            name="sourceCompetitorId"
            options={competitorOptions}
            rules={{ required: T.CANNOT_BE_EMPTY }}
            SelectProps={{ MenuProps: { sx: DRAWER_POPPER_SX } }}
          />
        </Grid>
      )}
    </>
  )
}

export default NewAccountSourceFields
